import { useEffect, useState } from "react";
import { useInquiry } from "../../context/InquiryContext";
import { FALLBACK_FOLLOWUP_OUTCOME, FALLBACK_FOLLOWUP_TYPE } from "../../../../utils/masterFallbacks";
import MasterSelect from "../../../CommonComponents/MasterSelect";
import { Button } from "../common/Button";
import { Card } from "../common/Card";
import { FormField, TextArea, TextInput } from "../common/FormInput";
import { Modal } from "../common/Modal";
import { createPortal } from "react-dom";
import {
  Addfollowup,
  deleteFollowup,
  getFollowup,
  updateFollowup,
} from "../../../../services/InqairyService";
import { toastAlert } from "../../../../helpers/toastAlert";
import { formatDate } from "../../../../utils/commonutils";
import { Delete, Edit, Note } from "@material-ui/icons";
import { EditNote, ModeEdit } from "@mui/icons-material";

function formatDateTime(iso) {
  try {
    return new Intl.DateTimeFormat("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function FollowUpPanel({
  inquiryId,
  variant = "inline",
  showTimeline = true,
  props,
  contactName,
  phone,
}) {
  const { getFollowUpsForInquiry, addFollowUp, loading } = useInquiry();
  const [modalOpen, setModalOpen] = useState(false);
  const [type, setType] = useState("Call");
  const [notes, setNotes] = useState("");
  const [outcome, setOutcome] = useState("Interested");
  const [nextFollowUpDate, setNextFollowUpDate] = useState("");
  const [Followupitem, setFollowupitem] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedFollowup, setSelectedFollowup] = useState(null);
  const [errors, setErrors] = useState({});
  const handleDeleteClick = (fu) => {
    setSelectedFollowup(fu);
    setDeleteOpen(true);
  };
  const handleEditClick = (fu) => {
    setSelectedFollowup(fu);

    setType(fu.type || "");
    setOutcome(fu.outcome || "");
    setNotes(fu.notes || "");
    setNextFollowUpDate(
      fu.nextFollowupDate ? fu.nextFollowupDate.split("T")[0] : "",
    );

    setEditOpen(true);
  };

  const handleDelete = async () => {
    if (!selectedFollowup) return;

    // setBusy(true);
    const res = await deleteFollowup(props, selectedFollowup._id);

    if (res?.status) {
      toastAlert("Follow-up deleted", "success");
      fetcfollowup();
    }

    // setBusy(false);
         setSelectedFollowup(null)
    setDeleteOpen(false);
  };
  const fetcfollowup = async () => {
    const res = await getFollowup(props, inquiryId);
    setFollowupitem(res?.data?.items || []);
  };
  useEffect(() => {
    if (inquiryId && variant !== "modal") {
      fetcfollowup();
    }
  }, [inquiryId]);
  const resetForm = () => {
    setType("Call");
    setNotes("");
    setOutcome("Interested");
    setNextFollowUpDate("");
    setErrors({});
  };

  const validate = () => {
    const e = {};
    if (!notes.trim()) e.notes = "Notes are required";
    if (!outcome) e.outcome = "Outcome is required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const formId = `followup-form-${inquiryId}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      inquiryId: inquiryId,
      type,
      outcome,
      notes,
      nextFollowupDate: nextFollowUpDate,
    };

    let res;

    if (selectedFollowup?._id) {
      res = await updateFollowup(props, selectedFollowup._id, payload);
    } else {
      res = await Addfollowup(props, payload);
    }
    if (res?.status) {
      toastAlert(res?.data?.message || "Success", "success");
    }
    fetcfollowup();
    resetForm();
    setModalOpen(false);
    setEditOpen(false);
    setSelectedFollowup(null);
  };

  const formBody = (
    <form id={formId} onSubmit={handleSubmit} className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <FormField label="Type" required>
          <MasterSelect
            variant="inquiry"
            group="followup_type"
            fallback={FALLBACK_FOLLOWUP_TYPE}
            value={type}
            onChange={(e) => setType(e.target.value)}
            disabled={loading}
          />
        </FormField>

        <FormField label="Outcome" required error={errors.outcome}>
          <MasterSelect
            variant="inquiry"
            group="followup_outcome"
            fallback={FALLBACK_FOLLOWUP_OUTCOME}
            value={outcome}
            onChange={(e) => setOutcome(e.target.value)}
            disabled={loading}
          />
        </FormField>
      </div>

      <FormField label="Notes" required error={errors.notes}>
        <TextArea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="What was discussed?"
          disabled={loading}
        />
      </FormField>

      <FormField label="Next follow-up date">
        <TextInput
          type="date"
          value={nextFollowUpDate}
          onChange={(e) => setNextFollowUpDate(e.target.value)}
          disabled={loading}
        />
      </FormField>
    </form>
  );

  const timeline = (
    <div className="mt-4">
      <div className="text-[11px] font-extrabold uppercase tracking-[0.12em] text-slate-500 mb-3">History</div>
      {Followupitem?.length === 0 ? (
        <p className="text-sm text-slate-500">No follow-ups yet.</p>
      ) : (
        Followupitem?.map((fu) => (
          <div key={fu._id} className="history-card">
            <div className="flex justify-between items-start gap-2">
              <div>
                <div className="font-bold text-slate-900">{fu.type}</div>
                <div className="text-xs text-slate-500 mt-0.5">{formatDateTime(fu.updatedAt || fu.createdAt)}</div>
              </div>
              <span className="status-pill done">{fu.outcome || "Logged"}</span>
            </div>
            {fu.notes && <p className="text-sm mt-2 text-slate-700">{fu.notes}</p>}
            <div className="flex gap-2 mt-2">
              <button type="button" className="schedule-link" onClick={() => handleEditClick(fu)}>Edit</button>
              <button type="button" className="schedule-link" style={{ color: "#b42318" }} onClick={() => handleDeleteClick(fu)}>Remove</button>
            </div>
          </div>
        ))
      )}
    </div>
  );

  // ================= MODAL VARIANT =================
  if (variant === "modal") {
    return (
      <>
        <button type="button" className="schedule-link" onClick={() => setModalOpen(true)}>
          Schedule
        </button>

        {modalOpen &&
          createPortal(
            <Modal
              open={modalOpen}
              onClose={() => {
                setModalOpen(false);
                resetForm();
              }}
              title="Schedule follow-up"
              footer={
                <>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      setModalOpen(false);
                      resetForm();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" form={formId}>
                    {loading ? "Saving…" : "Save"}
                  </Button>
                </>
              }
            >
              {formBody}
            </Modal>,
            document.body,
          )}
      </>
    );
  }

  const nextItem = Followupitem?.find((fu) => fu.nextFollowupDate);

  return (
    <Card>
      <div className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-slate-500">Follow-up</div>
      <div className="text-xl font-extrabold text-slate-900 mt-1 mb-3">{contactName || "This inquiry"}</div>
      {phone && (
        <div className="flex flex-wrap gap-2 mb-4">
          <a className="quick-action" href={`tel:${phone}`}>Call {phone}</a>
          <a className="quick-action" href={`https://wa.me/91${String(phone).replace(/\D/g, "")}`} target="_blank" rel="noreferrer">
            WhatsApp
          </a>
        </div>
      )}
      <div className="field-box mb-3">
        {nextItem
          ? `Next: ${formatDate(nextItem.nextFollowupDate)} · ${nextItem.type}`
          : "Nothing scheduled. Add a follow-up so this inquiry stays in motion."}
      </div>
      <button type="button" className="dashed-action mb-2" onClick={() => setEditOpen(true)}>
        + Schedule follow-up
      </button>
      {showTimeline && timeline}
      {deleteOpen &&
        createPortal(
          <Modal
            open={deleteOpen}
            onClose={() => setDeleteOpen(false)}
            title="Delete Follow-up?"
            footer={
              <>
                <Button variant="secondary" onClick={() => setDeleteOpen(false)}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                  Delete
                </Button>
              </>
            }
          >
            <p className="text-sm text-slate-600">
              This will delete this follow-up permanently.
            </p>
          </Modal>,
          document.body,
        )}
      {editOpen &&
        createPortal(
          <Modal
            open={editOpen}
            onClose={() => setEditOpen(false)}
            title={selectedFollowup ? "Edit Follow-up" : "Add Follow-up"}
            footer={
              <>
                <Button variant="secondary" onClick={() => setEditOpen(false)}>
                  Cancel
                </Button>
                <Button type="submit" form={formId}>
                  {selectedFollowup ? "Update" : "Save"}
                </Button>
              </>
            }
          >
            {formBody}
          </Modal>,
          document.body,
        )}
    </Card>
  );
}
